export default __webpack_public_path__ + "static/media/skilzen.c059fe9a.png";